import { render } from "./StandortLogo.vue?vue&type=template&id=b1dc8e1a&scoped=true"
import script from "./StandortLogo.vue?vue&type=script&lang=js"
export * from "./StandortLogo.vue?vue&type=script&lang=js"

import "./StandortLogo.vue?vue&type=style&index=0&id=b1dc8e1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1dc8e1a"]])

export default __exports__